import React, { Component } from "react";
// import PropTypes from "prop-types";
import { connect } from "react-redux";
import withAuth from "../../../components/withAuth";
import { Helmet } from "react-helmet";
import {
  Row,
  Header,
  Col,
  Button,
  Modal,
  Dropdown,
  HeaderPage,
  Alerts
} from "../../../ui";
import MarkersTableView from "../../../components/markers/tableView";

// STATE AND STORE
// LIBS
import API from "../../../api";
import Model from "../../../models/bilets";
import TinyMCE from "../../../components/tinymce";
import * as LibMarkers from "../../../lib/bilet/markers";
import Frame from "../../../components/frame";
import { Link } from "react-router-dom";

class SettingsTemplatesView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      titleHeader: "Шаблон документа",
      loading: true,
      saving: false,
      loadingFrame: false,
      template: {
        template_name: "",
        text: "",
        markers: []
      },
      markers: [],
      modals: {
        template: {
          content: "",
          isShow: false
        },
        markers: {
          isShow: false
        }
      },
      filials: {
        list: []
      },
      form: {
        filial: {
          value: "",
          isEdited: false,
          isError: false,
          errors: [],
          validate: Model.filial
        }
      }
    };
  }

  async componentDidMount() {
    const { id } = this.props.match.params;

    let template = {
      template_name: "",
      text: "",
      markers: []
    };

    let markers = [];

    try {
      let templateResult = await API.settings.template.getOne(id);

      template.template_name = templateResult.template_name || "";
      template.text = templateResult.text || "";
      template.markers = templateResult.markers || [];
    } catch (err) {
      console.log(err);
    }

    try {
      let markersResult = await API.settings.marker.getList();

      markers = markersResult || [];
    } catch (err) {
      console.log(err);
    }

    const filialsList = [
      {
        title: "Филиал не выбран",
        clear: true
      }
    ];

    try {
      const { data: filials } = await API.filials.getList({}, { full: true });

      (filials || []).forEach((item, i) => {
        if (i === 0) {
          filialsList.push({
            type: "hr"
          });
        }

        filialsList.push({
          id: item._id,
          title: item.name,
          onSelect: true,
          select: true
        });
      });
    } catch (err) {
      console.log(err);
    }

    this.setState({
      titleHeader: template.template_name,
      template,
      markers,
      loading: false,
      filials: {
        list: filialsList
      }
    });
  }

  handleSelectDropdown(item, name) {
    if (item && name) {
      let value = item.id || "";

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  }

  handleEditorChange = e => {
    let value = e.target.getContent();

    // let markers = getMakersInText(value, this.state.template[name].markers);

    this.setState({
      template: {
        text: value,
        markers: []
      }
    });
  };

  handleEditorSave = async e => {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      saving: true
    });

    try {
      let text = this.state.template.text;
      let markers = LibMarkers.getMakersInText(text, this.state.markers || []);
      const { id } = this.props.match.params;

      await API.settings.template.editOne(id, { text, markers });

      Alerts.success("Изменения сохранены");
    } catch (err) {
      console.log(err);
    }

    this.setState({
      saving: false
    });
  };

  openTemplateNewWindow = async e => {
    if (e) {
      e.preventDefault();
    }
    const { id } = this.props.match.params;

    let filialId = this.state.form.filial.value;
    if (filialId === "") {
      console.log("Филиал не выбран");
      return;
    }

    try {
      await this.handleEditorSave(e);

      // Open modal
      this.handleModalShow("template", true);

      // Get template with fill
      let content = await API.settings.template.testOne(id, filialId, {
        json: true
      });
      let modalName = "template";

      this.setState(prevState => {
        return {
          loadingFrame: false,
          modals: {
            ...prevState.modals,
            [modalName]: {
              ...prevState.modals[modalName],
              content
            }
          }
        };
      });
    } catch (err) {
      console.log(err);
    }
  };

  /**
   * Открытие мобального окна
   */
  handleModalShow = (modalName = "", isShow) => {
    this.setState(prevState => {
      return {
        loadingFrame: isShow,
        modals: {
          ...prevState.modals,
          [modalName]: {
            ...prevState.modals[modalName],
            isShow
          }
        }
      };
    });
  };

  render() {
    let { loading, saving } = this.state;

    return (
      <div>
        <Helmet>
          <script src="/js/tinymce/tinymce.min.js"></script>
        </Helmet>

        <HeaderPage
          title={this.state.titleHeader}
          back={this.props.history.goBack}
        ></HeaderPage>

        <Modal
          type="alert"
          width="md"
          height="full"
          title="Тест шаблона"
          show={this.state.modals.template.isShow}
          noCloseOnClickOutside={true}
          noHandlerOnClick={() => this.handleModalShow("template", false)}
        >
          <Frame
            title="Тест шаблона"
            loading={
              !this.state.modals.template.isShow || this.state.loadingFrame
            }
            content={this.state.modals.template.content}
          />
        </Modal>

        <Row align="center">
          <Col padding="no-top-bottom">
            <Button
              theme="primary"
              onClick={e => this.handleEditorSave(e)}
              disabled={loading || saving}
            >
              Сохранить
            </Button>
          </Col>
          <Col padding="no-top-bottom-left"></Col>
          <Col padding="no-top-bottom-left">
            <Dropdown
              label="Филиал:"
              name="filial"
              block={true}
              size="s"
              type="select"
              title="Выберите филиал"
              errors={this.state.form.filial.errors}
              list={this.state.filials.list}
              selectedId={this.state.form.filial.value}
              onSelect={item => {
                this.handleSelectDropdown(item, "filial");
              }}
            />
          </Col>
          <Col padding="no-top-bottom-left">
            <br />
            <Button
              disabled={
                this.state.form.filial.value === "" ||
                this.state.form.filial.value === "select" ||
                loading ||
                saving
              }
              outline={true}
              theme="warning"
              onClick={e => this.openTemplateNewWindow(e)}
            >
              Тест шаблона
            </Button>
          </Col>

          <Col padding="no-top-bottom-left">
            <br />
            {this.state.form.filial.value === "" ||
            this.state.form.filial.value === "select" ||
            loading ||
            saving ? (
              <Button disabled={true} outline={true} theme="primary">
                Печать
              </Button>
            ) : (
              <Button
                disabled={
                  this.state.form.filial.value === "" ||
                  this.state.form.filial.value === "select" ||
                  loading ||
                  saving
                }
                outline={true}
                theme="primary"
                type="as"
                as={Link}
                to={`/settings/templates/${this.props.match.params.id}/print/${this.state.form.filial.value}`}
              >
                Печать
              </Button>
            )}
          </Col>

          <Col padding="no-top-bottom-left">
            <br />
            <Button
              outline={this.state.modals.markers.isShow}
              onClick={e =>
                this.handleModalShow(
                  "markers",
                  !this.state.modals.markers.isShow
                )
              }
            >
              Маркеры
            </Button>
          </Col>
        </Row>

        {this.state.modals.markers.isShow ? (
          <Row>
            <Col xs={12}>
              <Header size={6}>Маркеры</Header>

              <MarkersTableView
                data={this.state.markers}
                loading={this.state.loading}
              />
            </Col>
          </Row>
        ) : null}

        <Row>
          <Col xs={12}>
            <br />
            <br />

            <TinyMCE
              loading={loading}
              saving={saving || this.state.modals.template.isShow}
              onBeforeSetContent={this.onBeforeSetContent}
              value={this.state.template.text}
              onChange={e => this.handleEditorChange(e)}
              disabled={saving}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  myUser: state.user
});

export default withAuth(connect(mapStateToProps)(SettingsTemplatesView));
